<template>
  <v-dialog v-model="open" width="740px" :fullscreen="isMobileBreakpoint">
    <v-card
      flat
      style="
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      "
    >
      <v-toolbar elevation="0">
        <v-toolbar-title class="body-regular-medium font-weight-medium ml-3">
          {{ $t('message.pages.funnel.previewFunnel.title') }}
          <p class="body-regular-smaller neutral-40-light--text mb-0">
            {{ $t('message.pages.funnel.previewFunnel.description') }}
          </p>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon
          @click="handleClose"
          class="close-icon mr-1"
          size="24"
          color="grey"
          style="cursor: pointer"
        >
          mdi-close
        </v-icon>
      </v-toolbar>
      <v-card-text class="px-4 input" v-if="!isFetching">
        <div style="border-radius: 8px">
          <iframe
            :id="`panda-${firstVideo.video_external_id}`"
            :src="firstVideo.video_player"
            style="border: none"
            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
            allowfullscreen="true"
            width="100%"
            height="400"
            fetchpriority="high"
          ></iframe>
        </div>
      </v-card-text>
      <v-card-text class="pt-4 px-4 input" v-else>
        <v-skeleton-loader
          height="400"
          class="pa-0"
          type="image"
        ></v-skeleton-loader>
      </v-card-text>
      <div
        style="width: 100%"
        class="d-flex justify-center align-center"
        v-if="isMobileBreakpoint"
      >
        <base-btn
          style="width: 90%"
          type="tertiary"
          class="mb-4"
          @click="handleClose"
          >{{ $t('message.close') }}</base-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import funnelApi from '@/services/funnelApi'
// import LoadingLogo from '../../../components/LoadingLogo.vue'
export default {
  name: 'PreviewFunnel',
  components: {},
  data: () => ({
    open: false,
    edit: false,
    dirty: false,
    isFetching: false,
    allVideos: [],
    funnel: {
      name: '',
      videos: [],
    },
    firstVideo: {},
  }),
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    embedPage() {
      return `<div style="position:relative;padding-top:56.25%;">
        <iframe id="panda-player"  style="
              border: none;
              border-radius:4px;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            " src="${this.firstVideo.video_player}" style="border:none;position:absolute;top:0;height:100%;width:100%" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"allowfullscreen=true>
      </iframe>
      </div>`
    },
  },
  watch: {
    open() {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
    },
  },

  mounted() {
    this.$root.$on('openPreviewFunnel', async (funnel) => {
      this.open = true
      this.isFetching = true
      await this.getAllAccountVideos()
      const res = await funnelApi.getFunnel(funnel.id)
      this.funnel = res.data.data
      const firstVideoId = this.funnel.videos?.find((row) => row.is_first)
      this.firstVideo = this.allVideos.find(
        (video) => firstVideoId?.id == video.id
      )
      this.isFetching = false
    })
  },
  beforeDestroy() {
    this.$root.$off('folderModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['addUser', 'editUser', 'addFolder', 'editFolder']),
    async handleConfirm() {
      await funnelApi.createFunnel(this.funnel)
      this.$root.$emit('reloadFunnels')
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: this.$t('message.pages.funnel.createModal.title'),
        type: 'success',
      })

      this.handleClose()
    },
    handleClose() {
      this.isFetching = true
      this.open = false
    },
    async getAllAccountVideos() {
      try {
        this.allVideos = await window.db.videos.toArray()
      } catch (error) {
        this.isFetching = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-toolbar {
  height: 70px !important;
  flex: inherit;
}
::v-deep .v-skeleton-loader__image {
  height: 100%;
}
::v-deep .v-toolbar__content {
  height: 70px !important;
}

.input::v-deep {
  label {
    left: -10px !important;
  }
}

.card-actions {
  border-top: 1px solid var(--v-neutral-95-lightest-base) !important;
}

.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .base-button {
    width: 50%;
  }

  .btn-tooltip {
    width: 50%;

    .base-button {
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.bgImg {
  background-size: contain;
}
</style>
